import { IAddressFields, RootState } from '@checkout/state';
import * as cx from 'classnames';
import { Field } from 'formik';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as Styles from './ContactDetailsForm.scss';
import { getContactDetailsFormModel } from './ContactDetailsFormModel';

interface IOwnProps {
  trySubmit?: boolean;
  fields: IAddressFields;
  formName: string;
  readOnly?: boolean;
  handleExtSubmitForm?: (submitFormFunction: () => void) => void;
}

interface IConnectetDispatchProps {}

interface IConnectedProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class ContactDetailsForm extends React.Component<Props, {}> {

  render() {
    const { readOnly, fields, formName, intl } = this.props;
    if (!fields) { return null; }

    const addersFormModel = getContactDetailsFormModel(fields, formName, intl);

    // TODO: build fieldset wrapper component ?
    const contactDetailsFieldsClassNames = cx({
      [Styles.fieldset]: true,
      [Styles.addressReadOnly]: readOnly,
    });

    // TODO: maybe build custom readonly component that shows only data that we want and with specific order/format?

    return (
      <div className={contactDetailsFieldsClassNames}>
        {addersFormModel.map((field) => {
          const { visible, name, ...fieldProps } = field;

          return visible && (
            <Field
              {...fieldProps}
              key={`${formName}.${name}`}
              id={`${formName}.${name}`}
              name={`${formName}.${name}`}
              readOnly={readOnly}
            />
          );
        })}
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {},
  )
)(ContactDetailsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/ContactDetailsForm/ContactDetailsForm.tsx